var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1b5cf3;}.cls-3{fill:#f92115;}.cls-4{fill:#190d15;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 20,
    width: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.88,18H6.81a.73.73,0,0,1-.73-.73V6.57A.73.73,0,0,1,6.4,6l5.53-3.83a.74.74,0,0,1,.83,0L18.29,6a.73.73,0,0,1,.32.6V17.29A.73.73,0,0,1,17.88,18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 5.86,
    cy: 6.89,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.86,6.89A4.93,4.93,0,0,0,9.68,3.7L6.4,6a.73.73,0,0,0-.32.6v5.3A5,5,0,0,0,10.86,6.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b706d998da081a35929e57e0f385d6c5.svg";
export { ForwardRef as ReactComponent };